import Link from "next/link";
import { ReactNode } from "react";

interface FooterLinkProps {
  href: string;
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}

/** Styled link for footer columns. */
export function FooterLink({
  href,
  children,
  onClick,
  className = "",
}: FooterLinkProps) {
  const baseClasses =
    "inline-flex min-h-11 items-center text-muted-foreground hover:text-primary text-sm transition-colors";

  return (
    <Link
      href={href}
      onClick={onClick}
      className={`${baseClasses} ${className}`}
    >
      {children}
    </Link>
  );
}
